import { ButtonGoToComponent } from "./button-go-to.component";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

@NgModule({
  imports: [CommonModule],
  declarations: [ButtonGoToComponent],
  exports: [ButtonGoToComponent]
})
export class ButtonGoToModule {}
